export class PopupList {
	popups: any = {
	'log-in': false,
	'sign-up': false,
	'add-stuff': false,
	'save-map': false,
	'share-map': false,
	'my-stuff': false,
	'profile': false,
	'forgot-password': false,
	'reset-password': false,
	'terms-conditions': false,
    'contact-support': false,
    'verify-email': false,
    'print': false,
	};
	shareMapInner: any = {
		'email': true,
		'link': false,
		'embed': false
	};
	myStuffInner: any = {
		'maps': true,
		'properties': false,
		'retailers': false,
		'pins': false,
		'removed': false,
		'history': false
	};
	signUpLogInInner: any = {
		'terms-conditions': false
	};
	removedSubInner: any = {
		'all' : true,
	  'properties': false,
    'retailers': false,
    'pins': false,
    'maps': false
  };
	mapsSubInner: any = {
		'all': true,
		'received': false,
		'shared': false
	};
}




// WEBPACK FOOTER //
// ./src/app/classes/popup-list.ts